import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConsultantNotesDialogData } from '../../models/leap-v2-attendance.model';

@Component({
  selector: 'leap-v2-consultant-notes-dialog',
  templateUrl: './leap-v2-consultant-notes-dialog.component.html',
  styleUrls: ['./leap-v2-consultant-notes-dialog.component.css'],
  standalone: false,
})
export class LeapV2ConsultantNotesDialogComponent {
  notes: string;

  constructor(
    public dialogRef: MatDialogRef<LeapV2ConsultantNotesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConsultantNotesDialogData
  ) {
    this.notes = data.existingNotes || '';
  }

  save(): void {
    this.dialogRef.close({ notes: this.notes.trim() });
  }
}
